export class User{
    constructor(
        public id:String,
        public firstname: String,
	    public middlename: String,
	    public firstlastname: String,
	    public middlelastname: String,	
	    public email: String,
	    public password: String,
	    public rol: String
    ){}
}